<template>
  <div class="repair-items app-region blank-t-v blank-l-h blank-r-h">
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <H2 style="margin-bottom: 40px">商品分类</H2>
        <a-form>
          <a-row>
            <a-col :md="8" :sm="24">
              <a-form-item label="分类名称" style="margin-bottom: 0px">
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="">
                <a-input
                  v-model="table.search.typeName"
                  placeholder="请输入商品分类名称"
                />
              </a-form-item>
            </a-col>
            <a-col :md="8 || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="{ float: 'left', overflow: 'hidden' } || {}"
              >
                <a-button type="primary" @click="toSearch">查询</a-button>
                <a-button
                  style="margin-left: 8px; font-style: italic"
                  @click="resetSearch"
                  >重置</a-button
                >
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="table-operator" style="margin-top: 20px">
        <a-button type="primary" icon="plus" @click="createType"
          >新增分类</a-button
        >
      </div>
      <a-spin tip="加载中..." :spinning="table.loading">
        <!-- 表格 -->
        <a-table
          :columns="columns"
          :data-source="table.data"
          rowKey="id"
          :pagination="table.page"
          @change="handlePageChange"
        >
          <span slot="status" slot-scope="data">
            <div>
              <a-switch
                :checked="data.status == 'normal'"
                @change="setGoodsTypeStatus(data)"
              />
            </div>
          </span>
          <span slot="action" slot-scope="text, data">
            <template>
              <a @click="handleEdit(data)">编辑</a>
              <a-divider type="vertical" />
              <a @click="handleDelete(data)">删除</a>
            </template>
          </span>
        </a-table>
      </a-spin>

      <a-modal
        :title="modal.title"
        :confirm-loading="modal.loading"
        v-model="modal.show"
        @ok="confirmModal"
        destroy-on-close
        centered
      >
        <a-form-model ref="form" :model="form" layout="vertical" :rules="rules">
          <a-form-model-item label="分类名称">
            <a-input v-model="form.typeName"></a-input>
          </a-form-model-item>
          <a-form-model-item label="分类说明">
            <a-input v-model="form.description"></a-input>
          </a-form-model-item>
        </a-form-model>
      </a-modal>
    </a-card>
  </div>
</template>

<script>
import GoodsTypeService from "@/io/goods_type.js";

export default {
  name: "Goodstype",
  data() {
    let self = this;
    return {
      // create model
      modal: {
        show: false,
        loading: false,
        // 0新增，1编辑
        type: 0,
      },
      rules: {},
      form: {
        typeName: null,
        description: null,
        id:null
      },

      queryParam: {},
      columns: [
        {
          title: "分类ID",
          dataIndex: "id",
          key: "id",
        },
        {
          title: "分类名称",
          dataIndex: "name",
          key: "name",
        },
        {
          title: "分类说明",
          dataIndex: "description",
          key: "description",
        },
        {
          title: "状态",
          key: "status",
          scopedSlots: { customRender: "status" },
        },
        {
          title: "操作",
          key: "action",
          scopedSlots: { customRender: "action" },
        },
      ],
      table: {
        editData: {
          typeName: null,
          description: null,
        },
        loading: false,
        data: [],
        search: {
          typeName: null,
        },
        page: {
          total: 10,
          current: 1,
          pageSize: 10,
          showQuickJumper: true,
          showSizeChanger: true,
          showTotal() {
            return `共${self.table.page.total}条`;
          },
        },
      },
    };
  },
  mounted() {
    this.getTypeList();
  },
  methods: {
    //   获取分类列表
    async getTypeList() {
      this.table.loading = true;
      const { page, search } = this.table;
      const res = await GoodsTypeService.list(
        page.current,
        page.pageSize,
        search.typeName
      );
      this.table.data = res.data.rows;
      this.table.page.total = res.data.total;
      this.table.loading = false;
    },
    //   更改状态
    async setGoodsTypeStatus({id,name,description,status}) {
      //   GoodsTypeService.edit()
      let resStatus = status == 'normal'? 'hidden': 'normal'
      const res = await GoodsTypeService.edit(id,name,description,resStatus)
      let index = this.table.data.findIndex((val)=>{
        return val.id == id
      })
      this.table.data[index].status = resStatus
    },
    // 编辑
    handleEdit(data) {
      this.modal.type = 1
      this.modal.show = true
      this.form.typeName = data.name
      this.form.description = data.description
      this.form.id = data.id
    },
    // 新建
    createType() {
      this.modal.type = 0
      this.modal.show = true;
      this.form.typeName = null
      this.form.description = null
      this.form.id = null
    },
    // 提交
    confirmModal() {
      this.$beforeFormSubmit(this.$refs.form, async () => {
        this.modal.loading = true;
        // 新增
        console.log(this.modal.type)
        if(this.modal.type == 0){
          await GoodsTypeService.add(this.form.typeName,this.form.description);
        this.$afterFormSubmit("创建成功", () => {
          this.getTypeList();
          this.modal.show = false;
          this.modal.loading = false
        });
        }else{
          await GoodsTypeService.edit(this.form.id,this.form.typeName,this.form.description);
           this.$afterFormSubmit("修改成功", () => {
          this.getTypeList();
          this.modal.show = false;
          this.modal.loading = false
        });
        }
      });
    },
    // 删除分类
    async handleDelete({ id }) {
      const res = await GoodsTypeService.delete(id);
      this.$message.info(res.msg);
      this.getTypeList();
    },
    handlePageChange(page) {
      this.table.page.current = page.current;
      this.table.page.pageSize = page.pageSize;
      this.getTypeList();
    },
    // 搜索
    toSearch() {
      this.table.page.current = 1;
      this.getTypeList();
    },
    // 重置
    resetSearch() {
      this.table.search.typeName = null;
    },
  },
};
</script>
